// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Facets$Showside from "../types/Facets.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as FiltersConfig2$Showside from "../types/FiltersConfig2.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function FiltersBadges$Badge(Props) {
  var disabled = Props.disabled;
  var facet = Props.facet;
  var label = Props.label;
  var onClick = Props.onClick;
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "filters-badge",
    dataId: facet,
    children: React.createElement("div", {
      "aria-label": "unselect filter: " + label,
      className: CSS$Showside.prefix(Cn.make(["inline-flex space-x-2 p-2 relative items-center justify-center cursor-pointer dark-hover darker-active bg-main hover:text-primary text-secondary", disabled ? "opacity-50 pointer-events-none" : ""])),
      role: "button",
      onClick: onClick
    }, React.createElement("div", {
      className: CSS$Showside.prefix("bg-primary opacity-5 absolute inset-0 rounded")
    }), React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow relative whitespace-nowrap font-medium")
    }, label), React.createElement("div", {
      className: CSS$Showside.prefix("relative")
    }, React.createElement(Unicons$Showside.UilTimes.make, {
      size: /* Px */{
        _0: 20
      }
    })))
  });
}
FiltersBadges$Badge.displayName = "FiltersBadges.Badge";
var Badge = {
  make: FiltersBadges$Badge
};
function FiltersBadges(Props) {
  var appliedFilters = Props.appliedFilters;
  var paddingOpt = Props.padding;
  var disableAllOpt = Props.disableAll;
  var padding = paddingOpt !== undefined ? paddingOpt : true;
  var disableAll = disableAllOpt !== undefined ? disableAllOpt : false;
  var match = ConfigurationProvider$Showside.use(undefined);
  RouterProvider$Showside.useRouter(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onChangeFilters = match$1.onChangeFilters;
  var match$2 = ViewportContext$Showside.use(undefined);
  var isMobile = match$2.isMobile;
  var filtersConfig = Belt_Option.flatMap(match.config.transitiveAccount, function (account) {
    return account.filtersConfig2;
  });
  var paddingNum = padding ? isMobile ? 12 : 24 : 0;
  var handleRemove = function (facet) {
    if (appliedFilters !== undefined) {
      return Curry._1(onChangeFilters, {
        entries: Belt_Array.keep(appliedFilters.entries, function (param) {
          return param.facet !== facet;
        }),
        minPrice: Belt_Option.keep(appliedFilters.minPrice, function (minPrice) {
          return Facets$Showside.toMinPriceFacet(minPrice) !== facet;
        }),
        maxPrice: Belt_Option.keep(appliedFilters.maxPrice, function (maxPrice) {
          return Facets$Showside.toMaxPriceFacet(maxPrice) !== facet;
        })
      });
    }
  };
  var items = appliedFilters !== undefined ? filtersConfig !== undefined ? Belt_Array.concat(Belt_Array.concat(Belt_Array.map(appliedFilters.entries, function (param) {
    var facet = param.facet;
    return React.createElement(FiltersBadges$Badge, {
      disabled: disableAll,
      facet: facet,
      label: Belt_Option.getWithDefault(FiltersConfig2$Showside.getLabelByFacet(filtersConfig, facet), facet),
      onClick: function (param) {
        handleRemove(facet);
      },
      key: facet
    });
  }), Belt_Option.mapWithDefault(appliedFilters.minPrice, [], function (minPrice) {
    var facet = Facets$Showside.toMinPriceFacet(minPrice);
    var label = "Min Price: " + minPrice.toString();
    return [React.createElement(FiltersBadges$Badge, {
      disabled: disableAll,
      facet: facet,
      label: label,
      onClick: function (param) {
        handleRemove(facet);
      },
      key: facet
    })];
  })), Belt_Option.mapWithDefault(appliedFilters.maxPrice, [], function (maxPrice) {
    var facet = Facets$Showside.toMaxPriceFacet(maxPrice);
    var label = "Max Price: " + maxPrice.toString();
    return [React.createElement(FiltersBadges$Badge, {
      disabled: disableAll,
      facet: facet,
      label: label,
      onClick: function (param) {
        handleRemove(facet);
      },
      key: facet
    })];
  })) : [] : [];
  if (appliedFilters === undefined) {
    return null;
  }
  var i = items.length;
  var items$1 = !isMobile && i > 1 ? Belt_Array.concat(items, [React.createElement(Link$Showside.make, {
    children: "Clear All Filters",
    unstyled: true,
    className: CSS$Showside.prefix("flex items-center h-11 text-base no-underline hover:underline text-tertiary cursor-pointer"),
    role: "button",
    ariaLabel: "clear all filters",
    dataTestId: "filters-clear-all-badge",
    onClick: function (param) {
      Curry._1(onChangeFilters, undefined);
    }
  })]) : items;
  return React.createElement("div", {
    "aria-label": "applied filters",
    className: Cn.make(["swiper-small-navigation", isMobile ? "" : "swiper-desktop", paddingNum !== 0 ? CSS$Showside.prefix("py-2") : "", CSS$Showside.prefix("flex-grow overflow-hidden")]),
    role: "group"
  }, React.createElement(Slider_Lazy$Showside.make, {
    items: items$1,
    spaceBetween: 12,
    slidesOffsetBefore: paddingNum,
    slidesOffsetAfter: paddingNum,
    enableFreeMode: true,
    enableNavigation: true,
    enableMousewheel: true,
    className: CSS$Showside.prefix("w-full"),
    restorationId: "smartnav-applied-filters"
  }));
}
FiltersBadges.displayName = "FiltersBadges";
var make = FiltersBadges;
export { Badge, make };
/* react Not a pure module */